import React, { useContext } from "react";

import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { ErrorMessage } from "@hookform/error-message";
import { errorMessage } from "utils/utilities";
import { AutoGrowTextarea } from "components/AutoGrowTextarea";
import NotyfContext from "contexts/NotyfContext";
import Select from "react-select";
import { useEffect } from "react";
import * as inspectionChecklistApi from "@api/inspectionChecklistApi";
import * as inspectionTreeChecklistApi from "@api/inspectionTreeChecklistApi";

export const EditDetailsModal = ({
    modalInfo,
    setModalInfo,
    view,
    isTreeInspection = false,
}) => {
    const notyf = useContext(NotyfContext);

    //
    // States
    //

    const schema = yup.object().shape({
        school: yup.object().required("This field is required").nullable(),
        // location: yup.string().required("This field is required").nullable(),
    });

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });

    //
    // Functions
    //

    const closeModal = () => {
        setModalInfo({ open: false });
        reset({});
    };

    const editDetailsApiCall = async (data) => {
        try {
            data.school_id = data?.school?.value;
            const response = isTreeInspection
                ? await inspectionTreeChecklistApi.updateTreeChecklistSchool(
                      modalInfo.id,
                      data
                  )
                : await inspectionChecklistApi.updateInspectionSchool(
                      modalInfo.id,
                      data
                  );

            if (response.status === 200) {
                notyf.open({
                    type: "success",
                    message: "Successfully updated the school",
                });
                closeModal();
                window.location.reload();
            }
        } catch (error) {
            notyf.open({
                type: "danger",
                message: "Something went wrong with the server",
            });
        }
    };

    useEffect(() => {
        reset({
            school: {
                value: modalInfo?.selectedSchool?.id,
                label: modalInfo?.selectedSchool?.name,
            },
            location: !isTreeInspection ? modalInfo?.selectedLocation : "",
        });
    }, [modalInfo, reset, isTreeInspection]);

    return (
        <Modal
            show={modalInfo.open}
            onHide={() => closeModal()}
            size="md"
            centered
        >
            <Modal.Header closeButton>Edit details</Modal.Header>
            <Modal.Body className="m-1">
                <Container fluid className="p-0">
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Form.Group className="mb-3">
                                    <Form.Label className="font-weight-bold">
                                        School
                                    </Form.Label>
                                    <Controller
                                        control={control}
                                        defaultValue=""
                                        name="school"
                                        render={({
                                            field: {
                                                value,
                                                onChange,
                                                onBlur,
                                                ref,
                                            },
                                        }) => (
                                            <Select
                                                inputRef={ref}
                                                className=""
                                                classNamePrefix="react-select "
                                                options={modalInfo.schools}
                                                isSearchable={true}
                                                isClearable={true}
                                                value={value}
                                                onChange={onChange}
                                                placeholder="Select school"
                                            />
                                        )}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="school"
                                        render={({ message }) =>
                                            errorMessage(message)
                                        }
                                    />
                                </Form.Group>
                            </Row>
                        </Col>
                        {!isTreeInspection && (
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label
                                        htmlFor="location"
                                        className="font-weight-bold"
                                    >
                                        Location
                                    </Form.Label>
                                    <Controller
                                        control={control}
                                        defaultValue=""
                                        name="location"
                                        render={({
                                            field: { value, onChange, onBlur },
                                        }) => (
                                            <>
                                                {view ? (
                                                    <p>{value}</p>
                                                ) : (
                                                    <AutoGrowTextarea
                                                        onChange={onChange}
                                                        fieldValue={
                                                            value !== null
                                                                ? value
                                                                : ""
                                                        }
                                                        errors={
                                                            errors?.location
                                                        }
                                                    />
                                                )}
                                            </>
                                        )}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="location"
                                        render={({ message }) =>
                                            errorMessage(message)
                                        }
                                    />
                                </Form.Group>
                            </Col>
                        )}
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Row>
                    <Col md={12} className="text-center">
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={handleSubmit(editDetailsApiCall)}
                        >
                            Submit
                        </Button>

                        <Button variant="link" onClick={() => closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    );
};
